/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { AuthService } from '../auth/AuthService';
import { ApiBack } from '../axios-config';

export interface IProfessionals {
    nome: string;
    registro_pessoal: string;
    email: string;
    id_empresa?: string;
    id_empreendimento?: string;
    id_barragem?: string;
    role: string;
    status?: boolean;
    id_superior?: string;
    registro_profissional?: string;
    telefone?: string;
    celular?: string;
    curriculum?: string;
    company_name?: string;
    registro?: string;
    professional_photo?: string;
    arquivo_registro_profissional?: string;
    arquivo_curriculum?: string;
    subordinado?: IProfessionals[];
    funcao?: string;
    uuid?: string;
}

const get = async (uuid:string, type: string): Promise<IProfessionals[] | Error> => {
    
    await AuthService.verify();

    try {
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.get(`./organograma?${type}=${uuid}`, {
            headers: {
                Authorization: `${token}`
            }
        });

        if (response.data) {
            return response.data;
        }

        return new Error('Erro ao listar registros.');
    } catch (error) {
        return new Error((error as { message: string }).message || 'Erro na requisição de listagem.');
    }
};

const getList = async (uuid:string, type: string): Promise<IProfessionals[] | Error> => {
    
    await AuthService.verify();

    try {
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.get(`./organograma/profissionais?${type}=${uuid}`, {
            headers: {
                Authorization: `${token}`
            }
        });

        if (response.data) {
            return response.data;
        }

        return new Error('Erro ao listar registros.');
    } catch (error) {
        return new Error((error as { message: string }).message || 'Erro na requisição de listagem.');
    }
};

const getById = async(uuid: string): Promise<IProfessionals | Error> => {

    await AuthService.verify();

    try {
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.get('./organograma', {
            params: {
                'id_profissional': uuid
            },
            headers: {
                Authorization: `${token}`
            }
        });

        if(response.data) {
            return response.data;
        }

        return new Error('Erro ao buscar profissional');
    } catch (error) {
        return new Error((error as { message: string }).message || 'Erro ao buscar profissional');
    }
};

const upgrade = async(uuid: string, data: IProfessionals): Promise<any | Error> => {

    await AuthService.verify();

    try{
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.put(`./organograma?uuid=${uuid}`, data, {
            headers: {
                Authorization: `${token}`
            }
        });

        if(response.data){
            return response.data;
        }
        
        return new Error('Falha ao atualizar profissionais');
    } catch (error) {
        return new Error((error as { menssage: string}).menssage || 'Error ao atualizar profissionais');
    }
};

const create = async (uuid: string, data: IProfessionals): Promise<any | Error> => {

    await AuthService.verify();
    
    try {
    
        const token = await AuthService.getAccessToken();
    
        const response = await ApiBack.post(`./organograma?uuid=${uuid}`, data, {
            headers: {
                Authorization: `${token}` 
            }
        });
    
        if (response.data) {
            return response ;
        }
    
        return new Error('Erro ao criar novo profissionais');
    } catch (error: any) {
        if (error.response && error.response.data && error.response.data.error && error.response.data.message) {
            return new Error(error.response.data.message);
        } else {
            return new Error((error as { message: string }).message || 'Erro ao criar profissionais');
        }
    }
};

const delet = async(uuid: string, data?: any): Promise<void | Error> => {

    await AuthService.verify();

    try {
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.delete(`./organograma?uuid=${uuid}`, {
            data: {},
            headers: {
                'Content-Type': 'application/json',
                Authorization: `${token}`,
            }
        });
    } catch (error) {
        return new Error((error as { message: string}).message || 'Erro ao deletar registro de profissional.');
    }
};


export const ProfessionalsServices = {
    get,
    getById,
    upgrade,
    create,
    delet,
    getList
};
